// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1ah_N","question":"Question_question__3S61K","description":"Question_description__1dvIe"};